// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Unstable_Grid2 = require("@mui/material/Unstable_Grid2").default;

function Expln_React_Column(props) {
  var children = props.children;
  var childXsOffset = props.childXsOffset;
  var spacing = props.spacing;
  var spacing$1 = spacing !== undefined ? spacing : 1;
  return React.createElement(Unstable_Grid2, {
              ref: props.gridRef,
              container: true,
              direction: "column",
              justifyContent: props.justifyContent,
              alignItems: props.alignItems,
              spacing: spacing$1,
              style: props.style,
              children: Caml_option.some(children !== undefined ? React.Children.map(Caml_option.valFromOption(children), (function (child, i) {
                            var style;
                            if (child == null) {
                              style = undefined;
                            } else {
                              var childProps = child.props;
                              if (childProps == null) {
                                style = undefined;
                              } else {
                                var childStyle = childProps.style;
                                if (childStyle == null) {
                                  style = undefined;
                                } else {
                                  var childDisplay = childStyle.display;
                                  style = (childDisplay == null) || childDisplay !== "none" ? undefined : ({
                                        display: "none"
                                      });
                                }
                              }
                            }
                            return React.createElement(Unstable_Grid2, {
                                        style: style,
                                        xsOffset: Belt_Option.flatMap(childXsOffset, (function (childXsOffset) {
                                                return Curry._1(childXsOffset, i);
                                              })),
                                        children: Caml_option.some(child)
                                      });
                          })) : null)
            });
}

var make = Expln_React_Column;

exports.make = make;
/* react Not a pure module */
